import { atom } from 'jotai';

export enum PageType {
  FrontPage,
  ProviderUniverse,
  Universe
}

export interface Props {
  pageType: PageType;
}

export type UrlParams = {
  universeTitle: string;
  providerId: string;
  universeId: string;
};

export const instantScrollBehaviorOnFocusKey = 'instantScrollBehaviorOnFocus';

export const MOVIE_STRIPE_ID = 3;
export const LIVE_TV_STRIPE_ID = 4;
export const FAVORITES_STRIPE_ID = 13;
export const RECORDINGS_STRIPE_ID = 16;

export const PORTRAIT_SCROLL_WIDTH = 297;
export const LANDSCAPE_SCROLL_WIDTH = 446;
export const WIDE_LANDSCAPE_SCROLL_WIDTH = 594;

export const HERO_SCROLL_HEIGHT = 200;

export const HERO_ELEMENT_HEIGHT = 482;
export const TOP_BAR_HEIGHT = 152;
export const STRIPE_ITEM_HEIGHT = 440;
export const PROVIDER_MENU_HEIGHT = 110;
